import React, { Component } from "react";
import CustomInput from "../../../../Utility/Components/CustomInput";
import AutosuggestComponent from "../../../../Utility/Components/AutosuggestComponent";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { useTranslation, withTranslation, Trans } from "react-i18next";
// import Utility from '../../../../../Utility/Utility';
// import DatePicker, { utils } from "react-modern-calendar-datepicker";
// import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { utils } from "@sentisso/react-modern-calendar-datepicker";
import '@sentisso/react-modern-calendar-datepicker/lib/DatePicker.css';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import ImageCropContent from "../../../../Utility/Components/ImageCropContent";
import ModalGlobal from "../../../../Utility/Components/ModalGlobal";
import { FileDrop } from "react-file-drop";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Utility from "../../../../Utility/Utility";
import ErrorBoundary from "../../../../Utility/Components/ErrorBoundary";
import Config from "../../../../Utility/Config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CustomButton from "../../../../Utility/Components/CustomButton";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";

import BootstrapSwitchButton from "bootstrap-switch-button-react";

class OrganizationModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: null,
            crop: {
                unit: "%",
                width: 30,
                aspect: 16 / 9,
            },
            croppedImageUrl: "",
        };
    }

    render() {
        const {
            addInputProfileImageChanged,
            addprofileImageSelected,
            steponehide,
            t,
            fromData,
        } = this.props;
        const {
            addUserImageChanged,
            addUserImageSelected,
            addUserFromData,
            addUserFromDataError,
            addUserImageError,
            orgDataEditFlag,
            userDataEditFlag,
            imageEditFrom,
            addUserInfoFromData,
            addUserInfoFromDataError,
            userCredentials,
        } = this.props;

        // const {}=this.state
        // console.log(">>>>>>>>>>>>>>>>>>>>", this.props.fromData.contractStartDate)
        // console.log(">>>>>>>>>>>>>>>>>>>>", this.props.fromData.contractEndDate)
        return (
            <>
                <div className="modalinnerbody">
                    <div className="firstinformation">
                        <div className="innerbodydimension">
                            <div className="col-md-12">
                                <div className="row edit_org_modal">
                                    {/* imtiaj */}
                                    {/* <div>
                                        <div className="catelog_content">
                                            <label>
                                                <span>Enable catalogue</span>
                                                <Switch
                                                    onChange={(e) => this.props.handleChangeCatalogue(e)}
                                                    checked={this.props.changeCatelogToggle}
                                                    className="catelog_switch"
                                                />
                                                <OverlayTrigger placement="bottom" overlay={<Tooltip>WhatsApp Business Catalog enables businesses to create digital storefronts within the app, showcasing products/services with details like descriptions and images, facilitating seamless interaction with customers for inquiries and orders directly through WhatsApp. It enhances customer engagement by offering a convenient platform for browsing and purchasing products/services, ultimately fostering stronger business-customer relationships.</Tooltip>}>
                                                    <span className="catelog_mode_info"><i className="fa fa-info-circle"></i></span>
                                                </OverlayTrigger>
                                            </label>
                                        </div>
                                    </div> */}
                                    {this.props.orgAddEditModalTitle == "Edit Organization" ? (
                                        <div className="toggle_button_sec">
                                            <div className="toggleSwitchBox">
                                                <div className="switch_btn_customize">
                                                    <span className="catalog_text">Enable catalogue</span>
                                                    <BootstrapSwitchButton
                                                        onlabel="Yes"
                                                        onstyle="success"
                                                        offlabel="No"
                                                        offstyle="danger"
                                                        style={"w-60 mx-2"}
                                                        checked={this.props.changeCatelogToggle}
                                                        onChange={(e) =>
                                                            this.props.handleChangeCatalogue(e)
                                                        }
                                                    />
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip>
                                                                WhatsApp Business Catalog enables businesses to
                                                                create digital storefronts within the app,
                                                                showcasing products/services with details like
                                                                descriptions and images, facilitating seamless
                                                                interaction with customers for inquiries and
                                                                orders directly through WhatsApp. It enhances
                                                                customer engagement by offering a convenient
                                                                platform for browsing and purchasing
                                                                products/services, ultimately fostering stronger
                                                                business-customer relationships.
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="catelog_mode_info">
                                                            <i className="fa fa-info-circle"></i>
                                                        </span>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>

                                            <div className="org_activate_phnumber">
                                                <div className="">
                                                    <CustomButton
                                                        onClick={this.props.handleActivatePhoneNumber}
                                                        className="activate_phn_no"
                                                        children={
                                                            this.props.disableActivePhnnoButton
                                                                ? "Phone number is active and synced"
                                                                : "Activate Phone Number"
                                                        }
                                                        disabled={this.props.disableActivePhnnoButton}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    {/* end imtiaj */}
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-12 paddingL">
                                                        <ErrorBoundary title="CustomInput Error">
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="Organization Name"
                                                                errorLabel={
                                                                    this.props.fromDataError.organization_name
                                                                }
                                                                name="organization_name"
                                                                type="text"
                                                                value={this.props.fromData.organization_name}
                                                                labelPresent={true}
                                                                onChange={(e) =>
                                                                    this.props.handelChange(
                                                                        e,
                                                                        "organization_name"
                                                                    )
                                                                }
                                                            />
                                                        </ErrorBoundary>
                                                    </div>
                                                    <div className="col-md-12 paddingL newClassAdd">
                                                        <OverlayTrigger
                                                            rootClose={true}
                                                            trigger="click"
                                                            placement="bottom"
                                                            overlay={
                                                                <Popover className="fixedBoxInner">
                                                                    <Popover.Content>
                                                                        <label className="fixedBox">
                                                                            The API call response includes IDs for
                                                                            each of the phone numbers connected to
                                                                            your WhatsApp Business Account.To get the
                                                                            ID visit{" "}
                                                                            <a
                                                                                href="https://developers.facebook.com"
                                                                                target="_blank"
                                                                            >
                                                                                https://developers.facebook.com
                                                                            </a>
                                                                        </label>
                                                                    </Popover.Content>
                                                                </Popover>
                                                            }
                                                        >
                                                            <i
                                                                className="fa fa-question-circle"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </OverlayTrigger>

                                                        <ErrorBoundary title="CustomInput Error">
                                                            <CustomInput
                                                                parentClassName="input_field_inner"
                                                                labelName="Whatsapp Phone Number Id"
                                                                errorLabel={
                                                                    this.props.fromDataError.phone_number_id
                                                                }
                                                                name="phone_number_id"
                                                                type="text"
                                                                value={this.props.fromData.phone_number_id}
                                                                labelPresent={true}
                                                                onChange={(e) =>
                                                                    this.props.handelChange(e, "phone_number_id")
                                                                }
                                                                readOnly={
                                                                    fromData.org_id != "" &&
                                                                        userCredentials.user_details.user_type !=
                                                                        "app_admin"
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                        </ErrorBoundary>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="input_field_inner phwithCountry">
                                                                <label className="input_label input_label_color">
                                                                    Whatsapp Business Phone Number
                                                                    <span
                                                                        className="required-star"
                                                                        style={{ color: "red" }}
                                                                    >
                                                                        *
                                                                    </span>
                                                                </label>

                                                                <PhoneInput
                                                                    disabled={
                                                                        fromData.org_id != "" &&
                                                                            userCredentials.user_details.user_type !=
                                                                            "app_admin"
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    country={Config.phoneNumberCountrySeet}
                                                                    value={this.props.whatsappBusinessPhoneNumber}
                                                                    onChange={(e) =>
                                                                        this.props.whatsappBusinessPhoneNumberInputHandleChangeFn(
                                                                            e
                                                                        )
                                                                    }
                                                                />
                                                                <div className="errorClass error_div">
                                                                    {this.props.whatsappBusinessPhoneNumberError}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="user_add_img modprofile org_modprofile">
                                                    <div className="userProfileImg">
                                                        {!this.props.addProfileImagePreviewShow ? (
                                                            <label className="custom-file-upload">
                                                                <span className="filetext">
                                                                    <img src={addprofileImageSelected} />
                                                                </span>
                                                                <span className="plusicon">
                                                                    <i
                                                                        className="fa fa-plus"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                    <input
                                                                        type="file"
                                                                        onChange={addInputProfileImageChanged}
                                                                    />
                                                                </span>
                                                            </label>
                                                        ) : (
                                                            <label className="custom-file-upload">
                                                                <img src={addprofileImageSelected} />
                                                                <span className="plusicon">
                                                                    <i
                                                                        className="fa fa-plus"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                    <input
                                                                        type="file"
                                                                        onChange={
                                                                            this.props.addInputProfileImageChanged
                                                                        }
                                                                    />
                                                                </span>
                                                            </label>
                                                        )}

                                                        <div className="col-md-12 errorClass error_div"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-12 paddingL">
                                                <ErrorBoundary title="CustomInput Error">
                                                    <CustomInput
                                                        parentClassName="input_field_inner"
                                                        labelName="Whatsapp Api Endpoint"
                                                        errorLabel={
                                                            this.props.fromDataError.whatsapp_api_endpoint
                                                        }
                                                        name="whatsapp_api_endpoint"
                                                        type="text"
                                                        value={this.props.fromData.whatsapp_api_endpoint}
                                                        labelPresent={true}
                                                        onChange={(e) =>
                                                            this.props.handelChange(
                                                                e,
                                                                "whatsapp_api_endpoint"
                                                            )
                                                        }
                                                        readOnly={
                                                            fromData.org_id != "" &&
                                                                userCredentials.user_details.user_type !=
                                                                "app_admin"
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                </ErrorBoundary>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12">
                                        <div className="row"> */}
                                    <div className="col-md-6">
                                        <div className="row">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="Token"
                                                    errorLabel={this.props.fromDataError.token}
                                                    name="token"
                                                    type="text"
                                                    value={this.props.fromData.token}
                                                    labelPresent={true}
                                                    onChange={(e) => this.props.handelChange(e, "token")}
                                                    readOnly={
                                                        fromData.org_id != "" &&
                                                            userCredentials.user_details.user_type !=
                                                            "app_admin"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>

                                    <div className="col-md-4 paddingL">
                                        <div className="dropdowninnerbox shiftdropdown">
                                            <label>
                                                Version <span>*</span>
                                            </label>
                                            <ErrorBoundary title="AutosuggestComponent Error">
                                                <AutosuggestComponent
                                                    handleOnChange={(e) => {
                                                        this.props.handleChangeVersionFn(e);
                                                    }}
                                                    options={this.props.versionOption}
                                                    selectedValue={this.props.fromData.selectedVersion}
                                                    name="type"
                                                    isMulti={false}
                                                    placeholder=""
                                                    //defaultMenuIsOpen={true}
                                                    isSearchable={true}
                                                    isDisabled={
                                                        fromData.org_id != "" &&
                                                            userCredentials.user_details.user_type !=
                                                            "app_admin"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </ErrorBoundary>
                                            <div className="errorClass error_div">
                                                {this.props.fromDataError.selectedVersion}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 paddingL newClassAdd delayTime">
                                        <OverlayTrigger
                                            rootClose={true}
                                            trigger="click"
                                            placement="bottom"
                                            overlay={
                                                <Popover className="fixedBoxInner">
                                                    <Popover.Content>
                                                        <label className="fixedBox">
                                                            The time delay between two consecutive messages
                                                            when sending bulk messages
                                                        </label>
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i
                                                className="fa fa-question-circle"
                                                aria-hidden="true"
                                                style={{ left: "45%" }}
                                            ></i>
                                        </OverlayTrigger>
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Delay Time"
                                                errorLabel={this.props.fromDataError.delay_time}
                                                name="delay_time"
                                                type="text"
                                                value={this.props.fromData.delay_time}
                                                labelPresent={true}
                                                // requiredStar={false}
                                                onChange={(e) =>
                                                    this.props.handelChange(e, "delay_time")
                                                }
                                                readOnly={
                                                    fromData.org_id != "" &&
                                                        userCredentials.user_details.user_type != "app_admin"
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="Marketed By Name"
                                                    //errorLabel={this.props.fromDataError.token}
                                                    name="marketed_by_name"
                                                    type="text"
                                                    value={this.props.fromData.marketed_by_name}
                                                    labelPresent={true}
                                                    requiredStar={false}
                                                    onChange={(e) =>
                                                        this.props.handelChange(e, "marketed_by_name")
                                                    }
                                                    readOnly={
                                                        fromData.org_id != "" &&
                                                            userCredentials.user_details.user_type !=
                                                            "app_admin"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                    {/* new field add start*/}
                                    <div className="col-md-6 paddingL">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Facebook App ID"
                                                errorLabel={this.props.fromDataError.facebook_app_id}
                                                name="facebook_app_id"
                                                type="text"
                                                value={this.props.fromData.facebook_app_id}
                                                labelPresent={true}
                                                requiredStar={true}
                                                onChange={(e) =>
                                                    this.props.handelChange(e, "facebook_app_id")
                                                }
                                                readOnly={
                                                    fromData.org_id != "" &&
                                                        userCredentials.user_details.user_type != "app_admin"
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="WhatsApp Business Account ID"
                                                    errorLabel={
                                                        this.props.fromDataError
                                                            .whatsapp_business_account_id
                                                    }
                                                    name="whatsapp_business_account_id"
                                                    type="text"
                                                    value={
                                                        this.props.fromData.whatsapp_business_account_id
                                                    }
                                                    labelPresent={true}
                                                    requiredStar={true}
                                                    onChange={(e) =>
                                                        this.props.handelChange(
                                                            e,
                                                            "whatsapp_business_account_id"
                                                        )
                                                    }
                                                    readOnly={
                                                        fromData.org_id != "" &&
                                                            userCredentials.user_details.user_type !=
                                                            "app_admin"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                    {/* new field add end*/}
                                    <div className="col-md-6 paddingL">
                                        <div className="col-md-12 paddingL paddingR">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="Marketed By Url"
                                                    //errorLabel={this.props.fromDataError.token}
                                                    name="marketed_by_url"
                                                    type="text"
                                                    value={this.props.fromData.marketed_by_url}
                                                    labelPresent={true}
                                                    requiredStar={false}
                                                    onChange={(e) =>
                                                        this.props.handelChange(e, "marketed_by_url")
                                                    }
                                                    readOnly={
                                                        fromData.org_id != "" &&
                                                            userCredentials.user_details.user_type !=
                                                            "app_admin"
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            </ErrorBoundary>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-7">
                                                    <div className="row">
                                                        <div className="packages_row_inner">
                                                            <label className="packages_title_label">
                                                                Subscription
                                                            </label>
                                                            <div className="visibleappcheck">
                                                                <label className="custom_checkbox_tick">
                                                                    Free Trial
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.props.freeTrialSubscription}
                                                                        onChange={(e) =>
                                                                            this.props.handleChangeSubscriptionChange(
                                                                                e,
                                                                                "freeTrial"
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            fromData.org_id != "" &&
                                                                                userCredentials.user_details.user_type !=
                                                                                "app_admin"
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <span className="checkmarkCheckbox"></span>
                                                                </label>
                                                            </div>
                                                            <div className="visibleappcheck">
                                                                <label className="custom_checkbox_tick">
                                                                    Monthly
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.props.monthlySubscription}
                                                                        onChange={(e) =>
                                                                            this.props.handleChangeSubscriptionChange(
                                                                                e,
                                                                                "monthly"
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            fromData.org_id != "" &&
                                                                                userCredentials.user_details.user_type !=
                                                                                "app_admin"
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <span className="checkmarkCheckbox"></span>
                                                                </label>
                                                            </div>
                                                            <div className="visibleappcheck">
                                                                <label className="custom_checkbox_tick">
                                                                    Yearly
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.props.yearlySubscription}
                                                                        onChange={(e) =>
                                                                            this.props.handleChangeSubscriptionChange(
                                                                                e,
                                                                                "yearly"
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            fromData.org_id != "" &&
                                                                                userCredentials.user_details.user_type !=
                                                                                "app_admin"
                                                                                ? true
                                                                                : false
                                                                        }
                                                                    />
                                                                    <span className="checkmarkCheckbox"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="mfaRequiredBoxes">
                                                        <div className="visibleappcheck">
                                                            <label className="custom_checkbox_tick">
                                                                MFA Required
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.props.fromData.is_mfa_required}
                                                                    onChange={(e) =>
                                                                        this.props.handelChange(
                                                                            e,
                                                                            "is_mfa_required"
                                                                        )
                                                                    }
                                                                />
                                                                <span className="checkmarkCheckbox"></span>
                                                            </label>
                                                        </div>
                                                        <span className="infoIconBox">
                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip>
                                                                        MFA is required in organizations to add an
                                                                        extra layer of security, reducing the risk
                                                                        of unauthorized access by requiring multiple
                                                                        verification methods beyond just a password.
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <i className="fa fa-info-circle"></i>
                                                            </OverlayTrigger>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            fromData.org_id != "" &&
                                                userCredentials.user_details.user_type != "app_admin"
                                                ? "col-md-6 fileUploadInnerBox fileUploadxyz marketedLogo"
                                                : "col-md-6 fileUploadInnerBox marketedLogo"
                                        }
                                    >
                                        <div className="row">
                                            <label className="logo_label">Marketed By Logo</label>
                                            <div
                                                className={
                                                    this.props.documentObjFileName != t("choosefile")
                                                        ? "filedragdropinner dragUploadComplete full_width"
                                                        : "filedragdropinner full_width"
                                                }
                                            >
                                                <ErrorBoundary title="FileDrop Error">
                                                    <FileDrop
                                                        onDrop={(files, event) => {
                                                            this.props.dropDocumentFileChange(files, event);
                                                        }}
                                                    >
                                                        <img
                                                            src={require("../../../../Utility/Public/images/filedownicon_.png")}
                                                        />
                                                        <p
                                                            className="droplabel"
                                                            data-tip={
                                                                this.props.documentObjFileName ==
                                                                    t("choosefile")
                                                                    ? t("dragdocument")
                                                                    : this.props.documentObjFileName
                                                            }
                                                        >
                                                            {this.props.documentObjFileName == t("choosefile")
                                                                ? t("dragdocument")
                                                                : this.props.documentObjFileName}
                                                        </p>
                                                    </FileDrop>
                                                </ErrorBoundary>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {/* <div className={this.props.documentObjFileName != t('choosefile') ? "uploadfiledoc chooseUploadComplete" : "uploadfiledoc"} > */}
                                                    <div className="uploadfiledoc">
                                                        <label className="orlabel">{t("or")} :</label>
                                                        <div className="file_name_property">
                                                            <label className="custom-file-upload">
                                                                <span data-tip={this.props.documentObjFileName}>
                                                                    {this.props.documentObjFileName}
                                                                </span>
                                                                <input
                                                                    type="file"
                                                                    onChange={this.props.uploadDocumentFileChange}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 errorClass error_div uploadfileError">
                                                        {this.props.documentError}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="packages_row_inner">
                                        {/* <label className='packages_title_label'>Message Credit Settings</label> */}

                                        <div className="visibleappcheck">
                                            <label className="custom_checkbox_tick">
                                                Funded by Mettle Tech
                                                <input
                                                    type="checkbox"
                                                    checked={this.props.isCheckboxChecked}
                                                    onChange={this.props.onCheckboxToggle}
                                                    disabled={
                                                        fromData.org_id !== "" &&
                                                        userCredentials.user_details.user_type !==
                                                        "app_admin"
                                                    }
                                                />
                                                <span className="checkmarkCheckbox"></span>
                                            </label>
                                        </div>
                                    </div>

                                    {this.props.showMessageCountFields && (
                                        <>
                                            <div className="col-md-6 paddingL">
                                                <ErrorBoundary title="CustomInput Error">
                                                    <CustomInput
                                                        parentClassName="input_field_inner"
                                                        labelName="Marketing Message Count"
                                                        name="marketing_message"
                                                        type="text"
                                                        value={this.props.fromData?.marketing_message ?? ""}
                                                        labelPresent={true}
                                                        requiredStar={false}
                                                        onChange={(e) =>
                                                            this.props.handelChange(e, "marketing_message")
                                                        }
                                                    />
                                                </ErrorBoundary>

                                                {this.props.orgAddEditModalTitle === "Edit Organization" && (
                                                    <div className="input_field_inner">
                                                        <label className="packages_title_label">
                                                            Balance Marketing Messages:&nbsp;
                                                            <span style={{ color: "#3F5FB5", fontWeight: "600" }}>
                                                                {this.props.fromData.balance_marketing_message ?? ""}
                                                            </span>
                                                        </label>
                                                    </div>
                                                )}

                                                <ErrorBoundary title="CustomInput Error">
                                                    <CustomInput
                                                        parentClassName="input_field_inner"
                                                        labelName="Utility Message Count"
                                                        name="utility_message"
                                                        type="text"
                                                        value={this.props.fromData.utility_message ?? ""}
                                                        labelPresent={true}
                                                        requiredStar={false}
                                                        onChange={(e) =>
                                                            this.props.handelChange(e, "utility_message")
                                                        }
                                                    />
                                                </ErrorBoundary>

                                                {this.props.orgAddEditModalTitle === "Edit Organization" && (
                                                    <div className="input_field_inner">
                                                        <label className="packages_title_label">
                                                            Balance Utility Messages:&nbsp;
                                                            <span style={{ color: "#3F5FB5", fontWeight: "600" }}>
                                                                {this.props.fromData.balance_utility_message ?? ""}
                                                            </span>
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}


                                    <div className="col-md-6 paddingL contractDate">
                                        <div
                                            className={
                                                fromData.org_id != "" &&
                                                    userCredentials.user_details.user_type != "app_admin"
                                                    ? "datepickerinnerbox datepickerinnerboxxyz"
                                                    : "datepickerinnerbox"
                                            }
                                        >
                                            <label>
                                                {`Contract Start Date`}
                                                <span style={{ color: "red" }}> *</span>
                                            </label>
                                            <ErrorBoundary title="DatePicker Error">
                                                <DatePicker
                                                    value={this.props.fromData.contractStartDate}
                                                    onChange={this.props.handleChangeContractDate.bind(
                                                        this,
                                                        "contractStartDate"
                                                    )}
                                                    formatInputText={() =>
                                                        this.props.formatDateInput("contractStartDate")
                                                    }
                                                    inputPlaceholder=" "
                                                    shouldHighlightWeekends
                                                    locale={Utility.customDatePicker()} // custom locale object
                                                    inputClassName="worker_datepicker"
                                                    minimumDate={utils().getToday()}
                                                    readOnly={true}
                                                />
                                            </ErrorBoundary>
                                            <div className="errorClass error_div">
                                                {this.props.fromDataError.contractStartDate}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 contractEndDate">
                                        <div className="row">
                                            <div
                                                className={
                                                    fromData.org_id != "" &&
                                                        userCredentials.user_details.user_type != "app_admin"
                                                        ? "datepickerinnerbox datepickerinnerboxxyz"
                                                        : "datepickerinnerbox"
                                                }
                                                style={{ width: "100%" }}
                                            >
                                                <label>
                                                    {`Contract End Date`}
                                                    <span style={{ color: "red" }}> *</span>
                                                </label>
                                                <ErrorBoundary title="DatePicker Error">
                                                    <DatePicker
                                                        value={this.props.fromData.contractEndDate}
                                                        onChange={this.props.handleChangeContractDate.bind(
                                                            this,
                                                            "contractEndDate"
                                                        )}
                                                        formatInputText={() =>
                                                            this.props.formatDateInput("contractEndDate")
                                                        }
                                                        inputPlaceholder=" "
                                                        shouldHighlightWeekends
                                                        locale={Utility.customDatePicker()} // custom locale object
                                                        inputClassName="worker_datepicker"
                                                        minimumDate={this.props.fromData.contractStartDate}
                                                    />
                                                </ErrorBoundary>
                                                <div className="errorClass error_div">
                                                    {this.props.fromDataError.contractEndDate}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 paddingL contractDate">
                                        <ErrorBoundary title="CustomInput Error">
                                            <div className="dropdowninnerbox">
                                                <label>
                                                    Unsubscribe Keys ({" "}
                                                    <span style={{ color: "#db5739" }}>
                                                        STOP and Unsubscribe are default opt-out keywords
                                                    </span>{" "}
                                                    )
                                                </label>
                                                <AutosuggestComponent
                                                    handleOnChange={(e) => {
                                                        this.props.handleChangeTags(e);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        this.props.handleKeyDownChangeTags(e);
                                                    }}
                                                    handleOnBlurChange={(e) => {
                                                        this.props.handleOnBlurChange(e);
                                                    }}
                                                    options={this.props.tagsOptions}
                                                    selectedValue={this.props.tagsValue}
                                                    name="tags"
                                                    isMulti={true}
                                                    placeholder="Select unsubscribe keys"
                                                    isDisabled={false}
                                                    isSearchable={true}
                                                    menuPlacement="bottom"
                                                    maxMenuHeight={150}
                                                    menuPosition="fixed"
                                                />
                                            </div>
                                        </ErrorBoundary>
                                    </div>

                                    <div className="col-md-6 paddingL contractDate">
                                        <ErrorBoundary title="CustomInput Error">
                                            {fromData.org_id == "" ? null : (
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="User Count"
                                                    errorLabel={this.props.fromDataError.user_count}
                                                    name="user_count"
                                                    type="text"
                                                    value={this.props.fromData.user_count}
                                                    labelPresent={true}
                                                    requiredStar={true}
                                                    onChange={(e) =>
                                                        this.props.handelChange(e, "user_count")
                                                    }
                                                //readOnly={fromData.org_id != "" && userCredentials.user_details.user_type != 'app_admin' ? true : false}
                                                />
                                            )}
                                        </ErrorBoundary>
                                    </div>
                                    {/* </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 text-center modfooterbtn">
                            <CustomButton
                                onClick={this.props.addCustomer}
                                className="savebtn"
                                children={fromData.org_id == "" ? t("Ajouter") : t("save ")}
                            // children={fromData.org_id == "" ? t('Ajouter') : t('edit')}
                            />
                            {/* <button type="button" className="savebtn" onClick={this.props.addCustomer}>{fromData.org_id == "" ? t('Ajouter') : t('edit')}</button> */}
                            <CustomButton
                                onClick={this.props.closeOrganizationModal}
                                className="savebtn cancelbtn"
                                children="Cancel"
                            />
                            {/* <button type="button" className="savebtn cancelbtn" onClick={this.props.closeOrganizationModal} >Cancel</button> */}
                        </div>
                    </div>
                </div>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={this.props.imageCropModalFlag}
                        onHide={this.props.imageCropModalHide}
                        onCancel={this.props.imageCropModalHide}
                        onSave={this.props.imageCropDataSave}
                        className="modalcustomize cropmodalcontent"
                        bodyClassName="cropmodalcontentbody"
                        headerclassName="close_btn_icon"
                        title={t("cropimage")}
                        footer={true}
                        closeButton={true}
                        saveButtonLabel={t("crop")}
                        saveButtonClassName="delconfirmbtn btn btn-primary"
                        cancelButtonClassName="delcancelbtn btn btn-primary"
                        body={
                            <>
                                <ErrorBoundary title="ImageCropContent Error">
                                    <ImageCropContent
                                        onImageLoaded={this.props.onImageLoaded}
                                        onComplete={this.props.onCropComplete}
                                        onCropChange={this.props.onCropChange}
                                        crop={this.props.crop}
                                        croppedImageUrl={this.props.croppedImageUrl}
                                        src={this.props.src}
                                        onCropComplete={this.props.onCropComplete}
                                        imageCropModalShow={this.props.imageCropModalShow}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>
            </>
        );
    }
}

OrganizationModalContent.propTypes = {};

OrganizationModalContent.defaultProps = {
    className: "modalcustomize mondimension",
    headerclassName: "close_btn_icon",
    buttonClassName: "btn btn-primary",
    BodyContent: "",
    buttonContent: "",
    bodyClassName: "",
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(withTranslation()(OrganizationModalContent))
);
